import React from 'react';
import {
  createFrontendPlugin,
  FrontendPlugin,
} from '@backstage/frontend-plugin-api';
import { compatWrapper } from '@backstage/core-compat-api';
import {
  CatalogFilterBlueprint,
  EntityCardBlueprint,
  EntityContentBlueprint,
} from '@backstage/plugin-catalog-react/alpha';
import { CrossplaneReadyFilterComponent } from './components/CrossplaneReadyFilter';
import { isCrossplaneAvailable } from './components/isCrossplaneAvailable';

// Re-export para uso no EntityPage enquanto ele estiver no compat bridge (S2.1)
export { default as CrossplaneCompositeResourcesTable } from './components/CrossplaneCompositeResourcesTable';
export { default as CrossplaneManagedResources } from './components/CrossplaneManagedResources';
export { default as CrossplaneClaimResourcesTable } from './components/CrossplaneClaimResourcesTable';
export { default as CrossplaneAllResourcesTable } from './components/CrossplaneAllResourcesTable';
export { default as CrossplaneV2ResourcesTable } from './components/CrossplaneV2ResourcesTable';
export { default as CrossplaneOverviewCardSelector } from './components/CrossplaneOverviewCardSelector';
export { default as CrossplaneResourcesTableSelector } from './components/CrossplaneResourcesTableSelector';
export { default as CrossplaneV2OverviewCard } from './components/CrossplaneV2OverviewCard';
export { default as CrossplaneV2ManagedResources } from './components/CrossplaneV2ManagedResources';
export { default as CrossplaneV2CompositeResourcesTable } from './components/CrossplaneV2CompositeResourcesTable';
export { default as CrossplaneV2UsedResourcesTable } from './components/CrossplaneV2UsedResourcesTable';
export { default as CrossplaneResourceGraphSelector } from './components/CrossplaneResourceGraphSelector';
export { default as CrossplaneV2ResourceGraph } from './components/CrossplaneV2ResourceGraph';
export { default as CrossplaneResourceGraph } from './components/CrossplaneResourceGraph';
export { default as CrossplaneOverviewCard } from './components/CrossplaneOverviewCard';

// O gate isCrossplaneAvailable (annotation terasky.backstage.io/crossplane-resource)
// restringe os cards/abas a entidades crossplane — sem ele quebrariam em outros
// kinds ao tentar resolver o cluster.

// Overview: apenas o seletor (escolhe v1/v2 em runtime). Usa type 'content' para
// ficar na coluna principal (esquerda). Os demais componentes (tabelas, grafo)
// vivem em abas, não no Overview.
const overviewCard = EntityCardBlueprint.make({
  name: 'crossplane-overview-card-selector',
  params: {
    type: 'content',
    filter: isCrossplaneAvailable,
    loader: async () => {
      const { default: Component } = await import(
        './components/CrossplaneOverviewCardSelector'
      );
      return compatWrapper(<Component />);
    },
  },
});

const makeEntityContent = (
  name: string,
  path: string,
  title: string,
  loader: () => Promise<{ default: React.ComponentType }>,
) =>
  EntityContentBlueprint.make({
    name,
    params: {
      path,
      title,
      filter: isCrossplaneAvailable,
      loader: async () => {
        const { default: Component } = await loader();
        return compatWrapper(<Component />);
      },
    },
  });

const crossplaneReadyFilter = CatalogFilterBlueprint.make({
  name: 'crossplane-ready',
  params: {
    loader: async () => <CrossplaneReadyFilterComponent />,
  },
});

export const crossplaneResourcesPlugin: FrontendPlugin = createFrontendPlugin({
  pluginId: 'crossplane-resources',
  extensions: [
    crossplaneReadyFilter,
    overviewCard,
    makeEntityContent(
      'crossplane-resources',
      '/crossplane-resources',
      'Crossplane Resources',
      () => import('./components/CrossplaneResourcesTableSelector'),
    ),
    makeEntityContent(
      'crossplane-graph',
      '/crossplane-graph',
      'Crossplane Graph',
      () => import('./components/CrossplaneResourceGraphSelector'),
    ),
  ],
});

export default crossplaneResourcesPlugin;
